import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type PlannerEditorTableViewerFragment = { __typename?: 'Viewer', hasLineActivationProvider: boolean, profile: { __typename?: 'PlannerProfile', childrenState: { __typename?: 'ChildrenState', answer: Types.ChildrenStateAnswer, children: Array<{ __typename?: 'Child', birthday: DateString, gender: Types.Gender }> }, address?: { __typename?: 'Address', postalCode: string, prefecture: string, city: string, town: string } | null } };

export const PlannerEditorTableViewerFragmentDoc = gql`
    fragment PlannerEditorTableViewer on Viewer {
  hasLineActivationProvider
  profile {
    childrenState {
      answer
      children {
        birthday
        gender
      }
    }
    address {
      postalCode
      prefecture
      city
      town
    }
  }
}
    `;